<!--
 * @Author: wenpan.cao@ecarxgroup.com
 * @Date: 2022-09-26 10:22:38
 * @LastEditTime: 2022-09-26 19:41:30
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @Description: 描述 日期范围选择器
-->


<template>
  <a-form-item
    v-if="!options.hidden"
    :label="label"
    :class="[{ 'ant-form-item-disabled': disabled }]"
    :required="!disabled && required"
  >
    <widgetItem
      :fieldName="widget.model"
      :rangePlaceholder="rangePlaceholder"
      :widget="widget"
      :disabled="disabled"
      :isNested="isNested"
      :showLabel="showLabel"
      :rowIndex="rowIndex"
      :parentName="parentName"
      :parentModel="parentModel"
      v-decorator="decorator"
      @noticeParent="handleNoticeParent"
      @change="handleChange"
    >
    </widgetItem>
  </a-form-item>
</template>
<script>
import props from '../../lib/props';
import widgetItem from './dateRange';

export default {
  name: 'wgDateRange',
  mixins: [props],
  components: {
    widgetItem,
  },
};
</script>
